// extracted by mini-css-extract-plugin
var _1 = "badge_badge__dawaq";
var _2 = "badge_badgecontent__gygm8";
var _3 = "badge_hastooltip__vyk32";
var _4 = "badge_tooltipicon__hcwvt";
export { _1 as "badge", _2 as "badgeContent", _3 as "hasTooltip", _4 as "tooltipIcon" }
